/*
  MORAY upsells — productpagina + cart drawer
  Werkt samen met:
    snippets/moray-combine-upsell.liquid      -> <moray-combine>
    snippets/moray-cart-complete-look.liquid  -> <moray-cart-look>
    assets/moray-upsell.css

  <moray-combine>
    Het vakje staat standaard uit; een maat kiezen vinkt het aan (bewuste keuze).
    Bij ADD TO CART met aangevinkt vakje voegen we eerst dit item toe via
    /cart/add.js en geven daarna de submit door aan het gewone product-form.
    Dat voegt de top toe en opent de drawer met beide regels.
    product-form.js blijft dus ongewijzigd.

  <moray-cart-look>
    "Complete the look" in de drawer: maat kiezen, toevoegen, drawer herrendert.

  Dit bestand kan twee keer geladen worden (productpagina + drawer), daarom
  staat alles achter customElements.get(...).
*/
(function () {
  'use strict';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function addItems(items, extra) {
    var body = { items: items };
    if (extra) {
      Object.keys(extra).forEach(function (key) {
        body[key] = extra[key];
      });
    }
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (parsed) {
        if (parsed && parsed.status) throw new Error(parsed.description || parsed.message || '');
        return parsed;
      });
  }

  /* -------------------------------------------------------------------------
     <moray-combine> — productpagina
  ------------------------------------------------------------------------- */
  if (!customElements.get('moray-combine')) {
    customElements.define(
      'moray-combine',
      class MorayCombine extends HTMLElement {
        connectedCallback() {
          if (this.ready) return;
          var source = this.querySelector('[data-combine-json]');
          try {
            this.data = JSON.parse(source.textContent);
          } catch (error) {
            return;
          }
          this.ready = true;
          this.items = this.data.items || [];
          this.index = 0;
          this.variantId = null;
          this.busy = false;

          this.toggle = this.querySelector('[data-combine-toggle]');
          this.errorEl = this.querySelector('[data-combine-error]');
          // Nooit vooraf aangevinkt, ook niet als de browser formulierstatus herstelt (terugknop).
          this.toggle.checked = false;

          this.onClick = this.onClick.bind(this);
          this.onToggle = this.onToggle.bind(this);
          this.onSubmit = this.onSubmit.bind(this);
          this.addEventListener('click', this.onClick);
          this.toggle.addEventListener('change', this.onToggle);
          // Capture-fase op document: we zien de submit vóór het product-form.
          document.addEventListener('submit', this.onSubmit, true);

          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
          }

          this.syncSingleVariant();
        }

        disconnectedCallback() {
          if (!this.ready) return;
          this.removeEventListener('click', this.onClick);
          this.toggle.removeEventListener('change', this.onToggle);
          document.removeEventListener('submit', this.onSubmit, true);
          if (this.unsubscribe) this.unsubscribe();
          this.ready = false;
        }

        get item() {
          return this.items[this.index];
        }

        // Product zonder maten: de enige variant is meteen gekozen.
        syncSingleVariant() {
          var item = this.item;
          if (item && item.variants.length === 1) this.variantId = String(item.variants[0].id);
        }

        onClick(event) {
          var size = event.target.closest('[data-combine-sizes] [data-variant-id]');
          if (size) {
            if (!size.disabled) this.selectSize(size.getAttribute('data-variant-id'));
            return;
          }
          var thumb = event.target.closest('[data-combine-thumb]');
          if (thumb) this.selectItem(Number(thumb.getAttribute('data-combine-thumb')));
        }

        selectSize(variantId) {
          this.variantId = String(variantId);
          this.querySelectorAll('[data-combine-sizes] [data-variant-id]').forEach(function (button) {
            var pressed = button.getAttribute('data-variant-id') === String(variantId);
            button.setAttribute('aria-pressed', pressed ? 'true' : 'false');
          });
          // Een maat kiezen is een bewuste keuze om dit item mee te nemen.
          this.toggle.checked = true;
          this.hideError();
          this.renderState();
        }

        selectItem(index) {
          var item = this.items[index];
          if (!item || index === this.index) return;
          this.index = index;
          this.variantId = null;
          // Ander model: de klant kiest opnieuw bewust (en een maat).
          this.toggle.checked = false;
          this.hideError();

          this.querySelectorAll('[data-combine-thumb]').forEach(function (thumb) {
            var pressed = Number(thumb.getAttribute('data-combine-thumb')) === index;
            thumb.setAttribute('aria-pressed', pressed ? 'true' : 'false');
          });
          this.querySelectorAll('[data-combine-link]').forEach(function (link) {
            link.href = item.url;
          });
          var title = this.querySelector('[data-combine-title]');
          if (title) title.textContent = item.title;
          var price = this.querySelector('[data-combine-price]');
          if (price) price.textContent = item.price;

          this.renderImage(item);
          this.renderSizes(item);
          this.syncSingleVariant();
          this.renderState();
        }

        renderImage(item) {
          var media = this.querySelector('.moray-combine__media');
          var image = this.querySelector('[data-combine-image]');
          if (!item.image) {
            if (image) image.hidden = true;
            return;
          }
          if (!image && media) {
            image = document.createElement('img');
            image.setAttribute('data-combine-image', '');
            image.alt = '';
            media.appendChild(image);
          }
          if (!image) return;
          image.hidden = false;
          image.width = 72;
          image.height = Math.round(72 / (item.ratio || 0.75));
          image.src = item.image;
        }

        renderSizes(item) {
          var wrap = this.querySelector('[data-combine-sizes-wrap]');
          var list = this.querySelector('[data-combine-sizes]');
          if (!wrap || !list) return;
          list.innerHTML = '';
          item.variants.forEach(function (variant) {
            var button = document.createElement('button');
            button.type = 'button';
            button.className = 'moray-combine__size';
            button.setAttribute('data-variant-id', variant.id);
            button.setAttribute('aria-pressed', 'false');
            button.textContent = variant.title;
            button.disabled = !variant.available;
            list.appendChild(button);
          });
          wrap.hidden = item.variants.length <= 1;
        }

        renderState() {
          var item = this.item;
          if (!item) return;
          this.classList.toggle('is-selected', this.toggle.checked);

          var addPrice = this.querySelector('[data-combine-add-price]');
          if (addPrice) addPrice.textContent = '+ ' + item.price;
          var badge = this.querySelector('[data-combine-badge]');
          if (badge) {
            badge.hidden = !item.combo;
            // Bedrag verschilt per toptype (bv. T-shirt vs. longsleeve op een denim-pagina)
            if (item.combo && item.save) badge.textContent = item.save;
          }

          var set = this.querySelector('[data-combine-set]');
          if (set) {
            set.hidden = !item.combo;
            set.querySelector('[data-combine-set-was]').textContent = item.setWas;
            set.querySelector('[data-combine-set-now]').textContent = item.setNow;
          }
          var perk = this.querySelector('[data-combine-perk]');
          if (perk) perk.hidden = !item.perk;
        }

        onToggle() {
          if (this.toggle.checked && !this.variantId) {
            this.showError(this.data.strings.chooseSize);
          } else {
            this.hideError();
          }
          this.renderState();
        }

        // Andere maat/kleur van de top: de sectie komt al vers gerenderd binnen,
        // dus we nemen de setprijzen daaruit over (geen prijsberekening in JS).
        onVariantChange(event) {
          var data = event && event.data;
          if (!data || data.sectionId !== this.dataset.sectionId || !data.html) return;
          var fresh = data.html.querySelector('[data-combine-json]');
          if (!fresh) return;
          try {
            var freshItems = JSON.parse(fresh.textContent).items || [];
            this.items.forEach(function (item) {
              for (var i = 0; i < freshItems.length; i++) {
                if (freshItems[i].id === item.id) {
                  item.setWas = freshItems[i].setWas;
                  item.setNow = freshItems[i].setNow;
                  item.perk = freshItems[i].perk;
                  break;
                }
              }
            });
            this.renderState();
          } catch (error) {
            /* huidige prijzen laten staan */
          }
        }

        onSubmit(event) {
          var form = event.target;
          // getAttribute: form.id geeft het <input name="id"> terug i.p.v. het id van het formulier
          if (!form || !form.getAttribute || form.getAttribute('id') !== this.dataset.formId) return;
          // Onze eigen doorgegeven submit: gewoon naar het product-form laten gaan.
          if (form.hasAttribute('data-moray-combine-pass')) return;
          if (this.busy) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }
          if (!this.toggle.checked) return;

          event.preventDefault();
          event.stopImmediatePropagation();

          if (!this.variantId) {
            this.showError(this.data.strings.chooseSize);
            this.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          this.addThenContinue(form);
        }

        addThenContinue(form) {
          var self = this;
          var button = form.querySelector('[type="submit"]');
          var spinner = button ? button.querySelector('.loading__spinner') : null;
          this.setBusy(true, button, spinner);

          addItems([{ id: Number(this.variantId), quantity: 1 }])
            .then(function (parsed) {
              self.setBusy(false, button, spinner);
              self.reset();
              var mainInput = form.querySelector('[name="id"]');
              self.watchMainAdd(parsed && parsed.items ? parsed.items[0] : null, mainInput ? mainInput.value : null);
              // Nu voegt het product-form de top toe en opent het de drawer.
              form.setAttribute('data-moray-combine-pass', '');
              try {
                if (typeof form.requestSubmit === 'function') {
                  form.requestSubmit();
                } else {
                  form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                }
              } finally {
                form.removeAttribute('data-moray-combine-pass');
              }
            })
            .catch(function (error) {
              self.setBusy(false, button, spinner);
              self.showError((error && error.message) || self.data.strings.error);
            });
        }

        // Lukt de top daarna niet (bv. uitverkocht), dan halen we dit item weer weg:
        // de klant koos een set, geen losse broek. Dawn meldt de fout zelf al.
        watchMainAdd(line, mainVariantId) {
          if (!line || !line.key || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
          var offError;
          var offUpdate;
          var timer;
          function stop() {
            if (offError) offError();
            if (offUpdate) offUpdate();
            clearTimeout(timer);
          }
          function isMain(event) {
            if (!event || event.source !== 'product-form') return false;
            return !mainVariantId || String(event.productVariantId) === String(mainVariantId);
          }
          offError = subscribe(PUB_SUB_EVENTS.cartError, function (event) {
            if (!isMain(event)) return;
            stop();
            fetch(root() + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: line.key, quantity: Math.max(0, (line.quantity || 1) - 1) })
            }).catch(function () {});
          });
          offUpdate = subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
            if (isMain(event)) stop();
          });
          timer = setTimeout(stop, 20000);
        }

        setBusy(on, button, spinner) {
          this.busy = on;
          this.classList.toggle('is-busy', on);
          if (button) button.classList.toggle('loading', on);
          if (spinner) spinner.classList.toggle('hidden', !on);
        }

        reset() {
          this.toggle.checked = false;
          this.variantId = null;
          this.querySelectorAll('[data-combine-sizes] [data-variant-id]').forEach(function (button) {
            button.setAttribute('aria-pressed', 'false');
          });
          this.syncSingleVariant();
          this.hideError();
          this.renderState();
        }

        showError(message) {
          if (!this.errorEl) return;
          this.errorEl.textContent = message;
          this.errorEl.hidden = false;
        }

        hideError() {
          if (!this.errorEl) return;
          this.errorEl.textContent = '';
          this.errorEl.hidden = true;
        }
      }
    );
  }

  /* -------------------------------------------------------------------------
     <moray-cart-look> — "Complete the look" in de cart drawer
  ------------------------------------------------------------------------- */
  if (!customElements.get('moray-cart-look')) {
    customElements.define(
      'moray-cart-look',
      class MorayCartLook extends HTMLElement {
        connectedCallback() {
          if (this.ready) return;
          this.ready = true;
          this.variantInput = this.querySelector('[data-look-variant]');
          this.button = this.querySelector('[data-look-add]');
          this.errorEl = this.querySelector('[data-look-error]');

          this.onChange = this.onChange.bind(this);
          this.onAdd = this.onAdd.bind(this);
          // <cart-drawer-items> behandelt elke 'change' als een aantal-wijziging;
          // de maatkeuze hier mag daar dus niet naartoe bubbelen.
          this.addEventListener('change', this.onChange);
          if (this.button) this.button.addEventListener('click', this.onAdd);
        }

        disconnectedCallback() {
          if (!this.ready) return;
          this.removeEventListener('change', this.onChange);
          if (this.button) this.button.removeEventListener('click', this.onAdd);
          this.ready = false;
        }

        onChange(event) {
          event.stopPropagation();
          this.hideError();
        }

        onAdd() {
          var self = this;
          var variantId = this.variantInput ? this.variantInput.value : '';
          if (!variantId) {
            this.showError(this.dataset.chooseSize);
            if (this.variantInput && this.variantInput.focus) this.variantInput.focus();
            return;
          }

          var drawer = document.querySelector('cart-drawer');
          var sections =
            drawer && typeof drawer.getSectionsToRender === 'function'
              ? drawer.getSectionsToRender().map(function (section) {
                  return section.id;
                })
              : [];

          this.setBusy(true);
          addItems([{ id: Number(variantId), quantity: 1 }], {
            sections: sections,
            sections_url: window.location.pathname
          })
            .then(function (parsed) {
              if (drawer && parsed.sections && typeof drawer.renderContents === 'function') {
                drawer.renderContents(parsed);
              } else {
                window.location.reload();
              }
            })
            .catch(function (error) {
              self.setBusy(false);
              self.showError((error && error.message) || self.dataset.error);
            });
        }

        setBusy(on) {
          this.classList.toggle('is-busy', on);
          if (!this.button) return;
          this.button.disabled = on;
          this.button.setAttribute('aria-busy', on ? 'true' : 'false');
        }

        showError(message) {
          if (!this.errorEl) return;
          this.errorEl.textContent = message || '';
          this.errorEl.hidden = false;
        }

        hideError() {
          if (!this.errorEl) return;
          this.errorEl.textContent = '';
          this.errorEl.hidden = true;
        }
      }
    );
  }
})();
